module.exports = __webpack_public_path__ + "static/media/chevron-circle-right.77691edf.svg";